module.exports = __webpack_public_path__ + "img/i-skype.7312617f.png";